export function createAndSubmitForm(token: string, url: string) {
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", url);
    const input = document.createElement("input");
    const input2 = document.createElement("input");

    input.setAttribute("name", "token");
    input.setAttribute("value", token);

    input2.setAttribute("name", "language");
    input2.setAttribute("value", "fa");

    form.appendChild(input);
    form.appendChild(input2);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
